import theme from 'src/theme';
import { DropDownItem } from 'src/shared/DropDown';

export type ContributorStatus = 'active' | 'away' | 'offline' | 'archive';

const STATUS_LABEL: Record<ContributorStatus, string> = {
    active: 'Active',
    away: 'Away',
    offline: 'Offline',
    archive: 'Archive'
};

export const CONTRIBUTOR_STATUS_OPTIONS: DropDownItem[] = [
    {
        value: 'active',
        title: 'Active',
        backgroundColor: theme.color.darkMintGreen,
        color: theme.color.brightGreen
    },
    {
        value: 'away',
        title: 'Away',
        backgroundColor: theme.color.darkMintYellow,
        color: theme.color.lightningYellow
    },
    {
        value: 'offline',
        title: 'Offline',
        backgroundColor: theme.color.darkMintRed,
        color: theme.color.orangyRed
    },
    {
        value: 'archive',
        title: 'Archive',
        backgroundColor: theme.color.blackRock,
        color: theme.color.white50
    }
];

export const contributorStatusLabel = (status?: string): string =>
    STATUS_LABEL[(status as ContributorStatus) ?? 'offline'] ??
    STATUS_LABEL.offline;

export const formatContributorTimestamp = (value?: string | null): string =>
    value ? value.slice(0, 19).replace('T', ' ') : '';
